import { HomeIcon } from 'asterX-UI/Icons/HomeIcon'

import BonusesTab from 'pages/Desktop/Home/Manager/components/Bonuses/BonusesTab'
import { RopInfo } from '../../RopInfo/RopInfo'
import { TasksList } from '../../TasksList/TasksList'
import { WlList } from '../../WlList/WlList'

export const ropTabsList = [
  {
    icon: HomeIcon,
    component: RopInfo
  },
  {
    label: 'РЛ',
    component: WlList
  },
  {
    label: 'Задачи',
    component: TasksList
  },
  { label: 'Бонусы', component: BonusesTab }
]
